import React, { useState, useEffect } from "react";
import { images } from "../../../common/Images";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper";
import { Colors, Web_url, ApiCall } from "../../../common/Const";
import String from "../../../lang/String";
import { useNavigate } from "react-router-dom";
import SkeletonEffect from "./SkeletonEffect";
import { useSelector } from "react-redux";
import store from "../../../redux/Store";

function Trending(props) {
  const { windowSize, trendingData } = props;
  // console.log("current size -->",windowSize);
  // console.log("trending -->", trendingData);
    const user = useSelector((state) => state.auth.user);
    const [cusId, setcusId] = useState(user && user.id > 0 ? user.id : 0);
    const RdxCart = useSelector((state) => state.cart);
  const navigate = useNavigate()
  const arr = [
    {
      title: "Gold Bangle",
      offer: "10% Offer",
    },
    {
      title: "Gold Ring Stone",
      offer: "30% Offer",
    },
    {
      title: "Gold Ring Stone",
      offer: "30% Offer",
    },
    {
      title: "Gold Ring Stone",
      offer: "30% Offer",
    },
    {
      title: "Gold Ring Stone",
      offer: "30% Offer",
    },
    {
      title: "Gold Ring Stone",
      offer: "10% Offer",
    },
  ];
  const handleClick  = (data)=>{

    // console.log('---->',data)
     window.scrollTo({ top: 0, behavior: "smooth" });
    navigate("/product-details",{state:{p_detail:data}});
  }
  // console.log(trendingData)
      const handleMostViewedItems = (id) => {

        
        if (cusId === 0) {
          const guestviewedProducts =
            JSON.parse(sessionStorage.getItem("guestviewedProducts")) || [];

          if (guestviewedProducts.includes(id)) {
            console.log("You have already viewed this product.");
            return;
          }

          //  const viewedParams ={customer_id:cusId,product_id:id};
          const viewedParams = { product_id: id };

          console.log(viewedParams);
          ApiCall("most_viewed", viewedParams)
            .then((data) => {
              console.log(data.message);
              guestviewedProducts.push(id);
              sessionStorage.setItem(
                "guestviewedProducts",
                JSON.stringify(guestviewedProducts)
              );
            })
            .catch((err) => console.log(err));
        } else {
          const viewedProducts =
            JSON.parse(sessionStorage.getItem("viewedProducts")) || [];

          if (viewedProducts.includes(id)) {
            console.log("You have already viewed this product.");
            return;
          }

          //  const viewedParams ={customer_id:cusId,product_id:id};
          const viewedParams = { product_id: id };

          console.log(viewedParams);
          ApiCall("most_viewed", viewedParams)
            .then((data) => {
              console.log(data.message);
              viewedProducts.push(id);
              sessionStorage.setItem(
                "viewedProducts",
                JSON.stringify(viewedProducts)
              );
            })
            .catch((err) => console.log(err));
        }
      };

      const isInCart = (varientdata) => {
        if (varientdata == "") {
          let cartarr = Object.values(RdxCart).filter((val) => {
            // console.log(val.product_id);
            if (
              val.product_id == varientdata.varient[0].product_id 
            ) {
              return true;
            } else {
              return false;
            }
          });
          console.log(cartarr);
    
          let returnVal = cartarr.length == 1 ?  true : false;
          // console.log(cartarr.length,'1tttttttttttttttttttttt');
          return returnVal
        } else {
          let cartarr = Object.values(RdxCart).filter((val) => {
            if (
              val.product_id == varientdata.varient[0].product_id 
            ) {
              return true;
            } else {
              return false;
            }
          });
          let returnVal = cartarr.length == 1 ?  true : false;
          return returnVal
          // console.log(cartarr.length,'sssssssssssssssssssss');
        }
      };
      
      async function additemtoCart(varientdata) {
        if (varientdata == "") {
          // store.dispatch({
          //   type: "addToCart",
          //   payload: {
          //     product_id: varientdata.product_id,
          //     product_name: varientdata.product_name,
          //     product_image: varientdata.product_image,
          //     order_sizes: varientdata.varient[0].size,
          //     karat: varientdata.varient[0].karat,
          //     weight: varientdata.varient[0].weight,
          //     order_price: varientdata.varient[0].offer_price,
          //     varient: varientdata.varient[0].varient,
          //     variant_id: varientdata.varient[0].id,
          //     packing_charges: varientdata.packing_charges,
          //   },
          // });
        } else {
          console.log({
            type: "addToCart",
            payload: {
              product_id: varientdata.varient[0].product_id,
              product_name: varientdata.product_name,
              product_image: varientdata.product_image,
              order_sizes: varientdata.varient[0].size,
              karat: varientdata.varient[0].karat,
              weight: varientdata.varient[0].weight,
              order_price: varientdata.varient[0].offer_price,
              varient: varientdata.varient[0].varient,
              variant_id: varientdata.varient[0].id,
              packing_charges: varientdata.packing_charges,
            },
          },"addToCartaddToCartaddToCart",varientdata)
          store.dispatch({
            type: "addToCart",
            payload: {
              product_id: varientdata.varient[0].product_id,
              product_name: varientdata.product_name,
              product_image: varientdata.product_image,
              order_sizes: varientdata.varient[0].size,
              karat: varientdata.varient[0].karat,
              weight: varientdata.varient[0].weight,
              order_price: varientdata.varient[0].offer_price,
              varient: varientdata.varient[0].varient,
              variant_id: varientdata.varient[0].id,
              packing_charges: varientdata.packing_charges,
            },
          });
        }
      }

  return (
    <div className="container my-4">
      <p className="h3 text-center m-3" style={{ color: Colors.Base_color }}>
        {String.home_headings.latest_trending}
      </p>
      <div
        className={windowSize > 512 ? "px-3 py-4 d-flex flex-row align-items-center justify-content-center" : "py-4 d-flex flex-row align-items-center justify-content-center"}
        role="button"
        style={{ backgroundColor: "rgb(133 147 24 / 14%)", borderRadius: "20px" }}
      >
        {/* <i class="fa-solid fa-circle-chevron-left review-swiper-button-prev"></i> */}
        <img
          className="review-swiper-button-prev"
          src={images.left}
          alt="left"
          width="30"
          height="30"
        />
        <Swiper
          // slidesPerView={4}
          slidesPerView={
            windowSize != null && windowSize >= 1440
              ? 6
              : windowSize >= 1366
              ? 5
              : windowSize >= 1024
              ? 4
              : windowSize >= 768
              ? 3
              : 1
          }
          spaceBetween={20}
          navigation={{
            nextEl: ".review-swiper-button-next",
            prevEl: ".review-swiper-button-prev",
          }}
          modules={[Navigation]}
          className="mySwiper"
        >
          {trendingData && trendingData != null ? (
            <>
              {trendingData.map((data) => {
                return (
                  <SwiperSlide className=" d-flex justify-content-center align-items-center">
                    <div
                      className="card"
                      style={{
                        width: windowSize >= 512 ? "12rem" : '12rem',
                        border: `1px solid ${Colors.Base_color}`,
                        borderRadius: "25px",
                        overflow: "hidden",
                      }}
                    >
                      <div style={{
                        display: 'flex',
                            flexDirection: 'row',
                            gap: '2px',
                            position: 'absolute',
                            right: '10px',
                            top: '10px',
                            alignItems: 'center',
                            justifyContent: 'center'
                      }} 
                      onClick={() =>{handleClick(data);handleMostViewedItems(data.product_id);}}>
                      <i style={{
                            color: Colors.Base_color,
                            fontSize: '10px'
                      }} class="fa-solid fa-star"></i>
                      <p style={{
                        margin:0,
                            color: Colors.Base_color,
                            fontSize: '10px'
                      }}>{data?.over_all_ratings ? data?.over_all_ratings : 5}</p>
                      </div>
                      <img
                        src={Web_url.Domain_url + data.product_image[0].url}
                        className="card-img-top"
                        alt="..."

                        
                      onClick={() =>{handleClick(data);handleMostViewedItems(data.product_id);}}
                      />
                      <div className="card-body">
                        <h5
                          className="card-title trd-title text-truncate"
                          style={{ color: Colors.Base_color }}
                          onClick={() =>{handleClick(data);handleMostViewedItems(data.product_id);}}
                        >
                           {data.product_name}
                        </h5>
                            {
                              console.log(data.varient[0]?.discount,"teeee")
                            }
                        <p className="card-text" style={{ color: "#000",margin:'0px' }} 
                      onClick={() =>{handleClick(data);handleMostViewedItems(data.product_id);}}>
                          ₹ {data.varient[0]?.discount == "0.00" ? data.varient[0].actual_price : data.varient[0].offer_price.toLocaleString("en-US")}
                          {/* <small
                            className="trd-strip-text mx-2"
                            style={{
                              color: "gray",
                              textDecoration: "line-through",
                            }}
                          >
                            {
                              console.log(data.varient[0]?.discount,"teeee")
                            }
                            ₹ {(data.varient[0] ? data.varient[0].actual_price : data.actual_price).toLocaleString("en-US")}
                          </small> */}
                        </p>
                        <p 
                      onClick={() =>{handleClick(data);handleMostViewedItems(data.product_id);}} className="card-text" style={{ color: "#000",margin:'0px',display:'flex',flexDirection:'row',alignItems:'center',gap:5,marginBottom:5 }}>
                        
                        <small
                            className="trd-strip-text"
                            style={{
                              color: "gray",
                              textDecoration: "line-through",
                              opacity:  data.varient[0]?.discount != "0.00"  ? 1 : 0 
                            }}
                            
                      onClick={() =>{handleClick(data);handleMostViewedItems(data.product_id);}}
                          >
                            ₹ {
                            data.varient[0] ? data.varient[0].actual_price : data.actual_price.toLocaleString("en-US")
                          }
                          </small>
                          <span class="jm-badge jm-ml-xxs"  
                      onClick={() =>{handleClick(data);handleMostViewedItems(data.product_id);}}
                            style={{
                              opacity:  data.varient[0]?.discount != "0.00"  ? 1 : 0 
                            }}> {data.varient[0]?.discount}% OFF </span>
                          </p>
                        <div className="d-flex align-items-center justify-content-center">
                          <button
                            className="btn text-center px-4"
                            style={{
                              backgroundColor: Colors.Base_color,
                              color: Colors.white_color,
                              fontSize:'15px',
                              width: '100%'
                            }}
                            onClick={()=>{
                              if(isInCart(data)){
                                navigate("/mycart")
                                window.scrollTo({ top: 0, behavior: "smooth" })
                              }else{
                                additemtoCart(data)
                              }
                            }}
                          >
                            {
                              isInCart(data) ? 'View Cart' : 'Add to bag'
                            }
                          </button>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </>
          ) : (
            <>
              {arr.map((data) => {
                return (
                  <SwiperSlide>
                    <SkeletonEffect className={"card"} height={"240px"} />
                    {/* <div
                      className="card"
                      style={{
                        width: "12rem",
                        border: `1px solid ${Colors.Base_color}`,
                        borderRadius: "25px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={images.card}
                        className="card-img-top"
                        alt="..."
                      />
                      <div className="card-body">
                        <h5
                          className="card-title trd-title"
                          style={{ color: Colors.Base_color }}
                        >
                          {data.title}
                        </h5>
                        <p className="card-text" style={{ color: "#000" }}>
                          ₹ 1,20,000{" "}
                          <small
                            className="trd-strip-text"
                            style={{
                              color: "gray",
                              textDecoration: "line-through",
                            }}
                          >
                            ₹ 1,20,000
                          </small>
                        </p>
                        <div className="d-flex align-items-center justify-content-center">
                          <button
                            className="btn text-center px-4"
                            style={{
                              backgroundColor: Colors.Base_color,
                              color: Colors.white_color,
                            }}
                          >
                            {data.offer}
                          </button>
                        </div>
                      </div>
                    </div> */}
                  </SwiperSlide>
                );
              })}
            </>
          )}
        </Swiper>
        {/* <i class="fa-solid fa-circle-chevron-right review-swiper-button-next"></i> */}
        <img
          className="review-swiper-button-next"
          src={images.right}
          alt="left"
          width="30"
          height="30"
        />
      </div>
      {/* <div className="d-flex justify-content-center mt-4 ">
        <button
          className="btn px-4 fw-bolder"
          style={{
            backgroundColor: Colors.Base_color,
            color: Colors.white_color,
          }}
        >
          {String.home_headings.show_more} &gt;&gt;
        </button>
      </div> */}
    </div>
  );
}

export default Trending;
